import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from '@mui/material';
import { FormEventHandler, ReactNode } from 'react';
import { useLanguage } from '../contexts/language';

const ConfirmationDialog = ({
  title,
  children,
  open,
  loading = false,
  submitDisabled = false,
  onClose,
  onConfirm,
  cancelButtonText,
  confirmButtonText,
  fullWidth,
  maxWidth,
}: {
  title?: string;
  children?: ReactNode;
  open: boolean;
  loading?: boolean;
  submitDisabled?: boolean;
  onClose: () => void;
  onConfirm: FormEventHandler;
  cancelButtonText?: string;
  confirmButtonText?: string;
  fullWidth?: DialogProps['fullWidth'];
  maxWidth?: DialogProps['maxWidth'];
}) => {
  const { t } = useLanguage();

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!loading) {
          onClose();
        }
      }}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      {open && (
        <>
          {title && <DialogTitle>{title}</DialogTitle>}
          <form
            onSubmit={event => {
              event.preventDefault();
              onConfirm(event);
            }}
          >
            {children && <DialogContent>{children}</DialogContent>}
            <DialogActions className="flex-col gap-2 md:flex-row md:gap-0">
              <Button
                onClick={onClose}
                disabled={loading}
                className="w-full md:w-auto max-md:bg-gray-200 max-md:hover:bg-gray-300 max-md:text-gray-700"
              >
                {cancelButtonText ?? t('content.cancel')}
              </Button>
              <Button
                variant="contained"
                type="submit"
                disabled={loading || submitDisabled}
                loading={loading}
                className="w-full md:w-auto"
              >
                {confirmButtonText ?? t('content.confirm')}
              </Button>
            </DialogActions>
          </form>
        </>
      )}
    </Dialog>
  );
};

export default ConfirmationDialog;

export const ConsequencesList = ({
  action,
  list,
}: {
  action: string;
  list: string[];
}) => {
  const { t } = useLanguage();
  return (
    <div>
      <p className="mb-4">{action}</p>
      <ul>
        {list.map(text => (
          <li key={text} className="list-disc list-item mb-2 ml-4">
            {text}
          </li>
        ))}
      </ul>
      <p className="my-4">{t('content.do-you-want-to-proceed')}</p>
    </div>
  );
};
